module.exports = __webpack_public_path__ + "static/media/RP-84.a658aabb.pdf";